import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import usePopper from 'use-popper';
import {
  MultiActionButtonWrapper,
  MultiActionButtonDot,
  ActionsWrapper,
  Action,
  ActionLink,
} from './styles';
import { Text } from '../../typography';
import { useOnClickOutside } from '../../redux/hooks';

const modifiers = {
  flip: { enabled: true },
  preventOverflow: { enabled: true },
  hide: { enabled: false },
};

function MultiActionButton(props) {
  const { name, actions, style } = props;
  const [clicked, setClicked] = React.useState(false);
  const { reference, popper } = usePopper({ placement: 'bottom-end', modifiers });

  const buttonRef = React.useRef();
  const popupRef = React.useRef();
  useOnClickOutside(buttonRef, () => setClicked(false), popupRef);

  const handleOnClick = React.useCallback((e) => {
    e.stopPropagation();
    setClicked((b) => !b);
  }, []);

  const ariaLabel = name ? `${name} - Multi Action Button` : 'Multi Action Button';
  return (
    <>
      <MultiActionButtonWrapper
        aria-label={ariaLabel}
        style={style}
        ref={(ref) => {
          reference.ref(ref);
          buttonRef.current = ref;
        }}
        onClick={handleOnClick}
      >
        <MultiActionButtonDot />
        <MultiActionButtonDot />
        <MultiActionButtonDot />
      </MultiActionButtonWrapper>
      {clicked &&
        ReactDOM.createPortal(
          <ActionsWrapper
            ref={(ref) => {
              popper.ref(ref);
              popupRef.current = ref;
            }}
            style={popper.styles}
          >
            {actions.map(({ action, to, label,labelColor, disabled }) =>
              to && !disabled ? (
                <ActionLink disabled={disabled} to={to} >
                  <Text style={{
                    color:  disabled ? 'inherit' : labelColor ?? 'inherit'
                  }} noMargin>{label}</Text>
                </ActionLink>
              ) : (
                <Action
                  disabled={disabled}
                  key={label}
                  onClick={(e) => {
                    e.stopPropagation();
                    action();
                  }}
                >
                  <Text style={{
                    color:  disabled ? 'inherit' : labelColor ?? 'inherit'
                  }} noMargin>{label}</Text>
                </Action>
              )
            )}
          </ActionsWrapper>,
          document.body
        )}
    </>
  );
}

MultiActionButton.propTypes = {
  name: PropTypes.string,
  actions: PropTypes.array.isRequired,
  style: PropTypes.object,
};

export default MultiActionButton;
